import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Console from './views/Console.vue'
import Users from './views/Users.vue'
import console from './views/Console.vue'
import Login from './views/Login.vue'
import NotFound from './views/NotFound.vue'
import register from './views/register.vue'
import enrollingProject from './views/user/enroll/enrollingProject.vue'
import enrollProjectAlready from './views/user/enroll/enrollProjectAlready.vue'
import forwardBidding from './views/user/bidding/forwardBidding.vue'
import biddingProject from './views/user/bidding/biddingProject.vue'
import userUpdate from './views/user/user/userUpdate.vue'
import userSearch from './views/user/user/userSearch.vue'
import bigScreen from './views/bigScreen1/index.vue'

import ladderBidding from './views/user/bidding/ladderBidding.vue'


import index from './views/index/index.vue'


Vue.use(Router)

const router = new Router({
  mode: 'hash',
  // base: process.env.BASE_URL,
   routes: [

    {
      path: '/',
      component: index,
      children: [
        {
          path: '/',
          component: () => import('./views/index/indexShow.vue'),
          meta: ['首页', "首页"]
        },
        {
          path: '/news',
          name:'news',
          component: () => import('./views/index/news/news.vue'),
          meta: ['新闻中心', "新闻中心"]
        },
        {
          path: '/localNews',
          name:'localNews',
          component: () => import('./views/index/news/localNews.vue'),
          meta: ['新闻中心', "地方要闻"]
        },
        {
          path: '/newsDetail/:type/:id',
          name:'newsDetail',
          component: () => import('./views/index/news/detail.vue'),
          meta: ['新闻中心', "新闻中心详情"]
        },
        {
          path: '/contactUs',
          name:'contactUs',
          component: () => import('./views/index/contact/contactUs.vue'),
          meta: ['交易项目', "转让项目"]
        },
        {
          path: '/transferList',
          name:'transferList',
          component: () => import('./views/index/transfer/transferList.vue'),
          meta: ['交易项目', "转让项目"]
        },
        {
          path: '/demandList',
          name:'demandList',
          component: () => import('./views/index/transfer/demandList.vue'),
          meta: ['交易项目', "需求项目"]
        },
        {
          path: '/stateOwnedList',
          name:'stateOwnedList',
          component: () => import('./views/index/transfer/stateOwnedList.vue'),
          meta: ['交易项目', "国有资产"]
        },
        {
          path: '/procureList',
          name:'procureList',
          component: () => import('./views/index/transfer/procureList.vue'),
          meta: ['交易项目', "采购项目"]
        },
        {
          path: '/demandDetail',
          name:'demandDetail',
          component: () => import('./views/index/transfer/demandDetail.vue'),
          meta: ['交易项目', "需求项目详情"]
        },
        {
          path: '/procureDetail',
          name:'procureDetail',
          component: () => import('./views/index/transfer/procureDetail.vue'),
          meta: ['交易项目', "采购项目详情"]
        },
        {
          path: '/transferDetail',
          name:'transferDetail',
          component: () => import('./views/index/transfer/transferDetail.vue'),
          meta: ['交易项目', "转出项目详情"]
        },
        {
          path: '/doneDealList',
          name:'doneDealList',
          component: () => import('./views/index/transfer/doneDealList.vue'),
          meta: ['交易项目', "成交项目列表"]
        },
        {
          path: '/doneDealDetail',
          name:'doneDealDetail',
          component: () => import('./views/index/transfer/doneDealDetail.vue'),
          meta: ['交易项目', "成交项目详情"]
        },
        {
          path: '/productList',
          name:'productList',
          component: () => import('./views/index/product/productList.vue'),
          meta: ['农产品交易', "农产品信息"]
        },
        {
          path: '/productDetail',
          name:'productDetail',
          component: () => import('./views/index/product/productDetail.vue'),
          meta: ['农产品交易', "农产品详细信息"]
        },

        {
          path: '/verifyList',
          name:'verifyList',
          component: () => import('./views/index/transfer/verifyList.vue'),
          meta: ['交易项目', "鉴证列表"]
        },
        {
          path: '/verifyDetail',
          name:'verifyDetail',
          component: () => import('./views/index/transfer/verifyDetail.vue'),
          meta: ['交易项目', "成交项目详情"]
        },

        {
          path: '/notice',
          name:'notice',
          component: () => import('./views/index/notice/notice.vue'),
          meta: ['通知公告', "通知公告"]
        },
        {
          path: '/dealNotice',
          name:'dealNotice',
          component: () => import('./views/index/notice/dealNotice.vue'),
          meta: ['通知公告', "处置公告"]
        },
        {
          path: '/noticeDetail',
          name:'noticeDetail',
          component: () => import('./views/index/notice/detail.vue'),
          meta: ['通知公告', "公告详情"]
        },
        {
          path: '/messageSearch',
          name:'messageSearch',
          component: () => import('./views/index/message/messageSearch.vue'),
          meta: ['互动交流', "互动交流"]
        },
        {
          path: '/fileDownloadList',
          name:'fileDownloadList',
          component: () => import('./views/index/fileDownload/fileDownloadList.vue'),
          meta: ['资料下载', "资料下载"]
        },
        {
          path: '/tradeRule',
          name:'tradeRule',
          component: () => import('./views/index/tradeRule/tradeRule.vue'),
          meta: ['交易指南', "交易规则"]
        },
        {
          path: '/tradeProcess',
          name:'tradeProcess',
          component: () => import('./views/index/tradeRule/tradeProcess.vue'),
          meta: ['交易指南', "交易流程"]
        },
        {
          path: '/tradeDetail',
          name:'tradeDetail',
          component: () => import('./views/index/tradeRule/detail.vue'),
          meta: ['交易指南', "详情"]
        },
        {
          path: '/showBiddingList',
          name:'showBiddingList',
          component: () => import('./views/index/bidding/showBiddingList.vue'),
          meta: ['实时竞价', "列表"]
        },






      ]
    },{
      path: '/login',
      component: Login
    },
    {
      path: '/register',
      component: register
    },
    {
      path: '/bigScreen',
      component: bigScreen
    },
    {
      path: '/forwardBidding',
      name: 'forwardBidding',
      component: forwardBidding
    },
    {
      path: '/ladderBidding',
      name: 'ladderBidding',
      component: ladderBidding
    },
 {
          path: '/ladderBiddingShow',
          name:'ladderBiddingShow',
          component: () => import('./views/user/bidding/ladderBiddingShow.vue'),
        },
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '/home',
          name: 'console',
          component: console
        },

        {
          path: '/userUpdate',
          name: 'userUpdate',
          component: userUpdate
        },
        {
          path: '/userSearch',
          name: 'userSearch',
          component: userSearch
        },
        {
          path: '/order-search',
          name:'order-search',
          component: () => import('./views/user/shop/order-search.vue'),
          meta: ['农产品交易', "订单管理"]
        },
        // {
        //   path: '/mybiddingProject',
        //   name: 'mybiddingProject',
        //   component: mybiddingProject
        // },

        {
          path: '/enrollingProject',
          component: enrollingProject
        } ,{
          path: '/enrollProjectAlready',
          component: enrollProjectAlready
        },
        ,{
          path: '/biddingProject',
          component: biddingProject
        },
        {
          path: '/redorderRecordList',
         component: () => import('./views/user/bidding/redorderRecordList.vue'),
        },
        {
          path: '/successProjectList',
         component: () => import('./views/user/bidding/successProjectList.vue'),
        },
        {
          path: '/test',
         component: () => import('./views/user/bidding/test.vue'),
        },


      ]
    },
    {
      path: '*',
      redirect: { path: '/404' }
    }
  ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const LOGINURL = '/login'
  let url, token

  url = to.path
  token = localStorage.getItem('token');

  // if (url === LOGINURL) {
  //   localStorage.setItem("isAlreadyLogin","");
  // }

  if (url != LOGINURL&&localStorage.getItem("isExit")==0&&url!='/index') {
     //next({ path: LOGINURL })
  }


  // 判断是否登录
  if ((token==""||token==null) && url !== LOGINURL&&url!="/register"&&url!='/index') {
    //next({ path: LOGINURL })
    next()
  } else {
    next()
  }
})

export default router
